export default "__VITE_ASSET__BP4LtncY__"